import React from 'react';
import { connect } from 'react-redux';
import { jsx, css } from '@emotion/core';
import { primary_s5_l70 } from '../lib/colors';

const getStyles = (primaryColor, uiVariantInputText) => css`
  .form-control {
    border-radius: ${uiVariantInputText === '1'
      ? '12px'
      : uiVariantInputText === '3'
      ? '30px'
      : 0};

    &:focus {
      border-color: ${primaryColor};
    }
  }
  .help-block {
    color: ${primary_s5_l70(primaryColor)};
  }
`;

const SelectField = props => {
  const {
    id,
    input,
    label,
    options,
    nullOption,
    meta: { asyncValidating, touched, error },
    primaryColor,
    uiVariantInputText,
  } = props;
  return (
    <div
      css={getStyles(primaryColor, uiVariantInputText)}
      className={`form-group ${touched && error && 'error'}`}
    >
      <label htmlFor={id} className="col-sm-4 control-label">
        {label}
      </label>
      <div className="col-sm-8">
        <select
          {...input}
          placeholder={label}
          className="form-control"
          style={
            label === 'provider' || label === 'providerId'
              ? { display: 'none' }
              : null
          }
        >
          {nullOption && (
            <option value={nullOption.value}>{nullOption.label}</option>
          )}
          {options.map(o => (
            <option value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
      {touched && error && <div className="error-text">{error}</div>}
    </div>
  );
};

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantInputText: state.store.data.uiVariants.inputText,
});

export default connect(mapStateToProps)(SelectField);
